import { createAsyncThunk } from "@reduxjs/toolkit";

import { createRegistrations } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const saveRegistrations = createAsyncThunk(
  "registrations/saveRegistrations",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { adapter, questions, recaptcha } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { answers } = questions;
      const { recaptchaToken } = recaptcha;
      const recaptchaParam = recaptchaToken && {
        gRecaptchaResponse: recaptchaToken
      };

      const response = await createRegistrations(token, baseUrl, {
        signupFormResponse: answers,
        ...recaptchaParam
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
